@if (voteType === 'article') {
  <div class="react">
    @if (voteSum() > 0) {
      <div class="article-icons" (click)="openDialog()" (keypress)="openDialog()" tabindex="0">
        @for (vote of votes | keyvalue; track vote) {
          <img [src]="findVote(vote.key).icon" alt="icoon van {{findVote(vote.key).value}}" />
        }
        <span class="vote-count">{{ voteSum() }}</span>
      </div>
    }
    <div class="react__spacer"></div>
    @if (!myVote) {
      <button
        mat-icon-button
        class="react-btn"
        [matMenuTriggerFor]="reactionMenu"
        matTooltip="Reageer"
        >
        <mat-icon>add_reaction</mat-icon>
      </button>
    }
    @if (myVote) {
      <button
        mat-icon-button
        class="react-btn react-btn--voted"
        (click)="removeVote()"
        matTooltip="Reactie verwijderen"
        >
        <img [src]="findVote(myVote.voteType).icon" class="react-btn__img" alt="icon van {{findVote(myVote.voteType).value}}" />
      </button>
    }
  </div>
}

@if (voteType === 'comment') {
  <div class="comment-actions">
    @if (!myVote) {
      <button class="action-button" [matMenuTriggerFor]="reactionMenu">
        leuk
      </button>
    }
    @if (myVote) {
      <button class="action-button voted" (click)="removeVote()" tabindex="0">
        leuk
      </button>
    }
    @if (showReactButton) {
      <span class="dot-seperator"> </span>
      @if (showReactButton) {
        <button
          class="action-button"
          (click)="reactClicked.emit()"
          >
          reageer
        </button>
      }
    }
    @if (showBanButton) {
      <span class="dot-seperator"> </span>
      <button
        class="action-button"
        (click)="banClicked.emit()"
        [class.voted]="bannedComment"
        >
        {{ bannedComment ? "ontbannen" : "verbannen" }}
      </button>
    }
    @if (timePosted) {
      <span class="dot-seperator"> </span>
      <span class="time">{{ timePosted | amTimeAgo }} </span>
    }
  </div>
}
@if (voteType === 'comment' && voteSum() > 0) {
  <button
    class="comment-icons"
    [class.my-vote]="myVote"
    (click)="openDialog()"
    matTooltipClass="custom-tooltip"
    >
    @for (vote of votes | keyvalue; track vote) {
      <img [src]="findVote(vote.key).icon" alt="icoon van {{findVote(vote.key).value}}" />
    }
    <div class="vote-count">
      {{ voteSum() }}
    </div>
  </button>
}

<mat-menu #reactionMenu="matMenu" yPosition="above">
  <ng-template matMenuContent let-id="id">
    @for (button of voteButtons; track button) {
      <button
        mat-menu-item
        (click)="addVote(button)"
        >
        <img [src]="button.icon" class="vote-icon" alt="icoon van {{button.value}}" />
        <span>{{ button.value }}</span>
      </button>
    }
  </ng-template>
</mat-menu>
